<template>
  <div class="login">
    <div class="login__overlay">
      <div class="login__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="login__logo">
        <h2 class="login__title">Вход</h2>
        <p class="login__text">Введите свой адрес электронной почты и пароль для входа в систему</p>
        <form @submit.prevent="login">
          <div class="login__inputWrapper">
            <input
              class="login__input"
              type="email"
              v-model="email"
              required
              @focus="focused.email = true"
              @blur="focused.email = email !== ''"
            />
            <label :class="{ floating: focused.email || email !== '' }">E-mail</label>
          </div>
          <div class="login__inputWrapper">
            <input
              class="login__input"
              type="password"
              v-model="password"
              required
              @focus="focused.password = true"
              @blur="focused.password = password !== ''"
            />
            <label :class="{ floating: focused.password || password !== '' }">Пароль</label>
          </div>
          <p @click="resetPassword" class="login__reset-password">забыли пароль?</p>
          <div class="login__switchWrapper">
            <label class="login__switch">
              <input type="checkbox" v-model="rememberMe" />
              <span class="login__slider"></span>
            </label>
            <span>Запомнить меня</span>
          </div>

          <button
            class="login__btn"
            :disabled="isLoading"
            :class="{ 'login__btn--loading': isLoading }"
            type="submit"
          >
            {{ isLoading ? 'Уже входим…' : 'Войти' }}
          </button>
          <p v-if="error" class="login__error">{{ error }}</p>
        </form>
        <p class="login__subtitle">У вас нет учетной записи?</p>
        <button @click="this.$router.push('/signup')" class="login__link">Зарегистрируйтесь</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      rememberMe: false,
      error: null,
      isLoading: false, // Флаг состояния загрузки
      focused: {
        email: false,
        password: false,
      },
    };
  },
  methods: {
    async login() {
      this.error = null;
      this.isLoading = true; // Устанавливаем состояние загрузки
      try {
        // Создаем объект FormData
        const formData = new FormData();
        formData.append('username', this.email);
        formData.append('password', this.password);
        formData.append('rememberMe', this.rememberMe);

        await axios.post('/api/pis/v1/user/signin', formData, {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            'Content-Type': 'multipart/form-data', // Указываем тип контента
          },
        });

        await this.getUserData();

        this.$router.push('/');

      } catch (error) {
        this.error = 'Ошибка авторизации. Проверьте данные и попробуйте снова.';
        console.error('Ошибка при авторизации:', error);
        this.isLoading = false; // Сбрасываем состояние загрузки
      }
    },
    async getUserData() {
      try {
        const response = await axios.get('/api/pis/v1/user/user_info', {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
          },
        });

        // Получаем данные пользователя
        const userInfo = response.data;

        // Сохраняем весь объект userInfo в хранилище
        const storage = this.rememberMe ? localStorage : sessionStorage;
        storage.setItem('userInfo', JSON.stringify(userInfo));

        // Обновляем локальное состояние
        this.userInfo = userInfo;
      } catch (error) {
        console.error('Ошибка при получении данных пользователя:', error);
        this.error = 'Не удалось получить данные пользователя. Попробуйте позже.';
      }
    },
    resetPassword(){
      this.$router.push('/reset-password')
    },

  },
};
</script>

<style scoped>
.login__overlay {
  background-image: url("../assets/img/signup-bg.png");
  background-position: center;
  background-size: cover;
}
</style>